export default __webpack_public_path__ + "static/media/bernaymini.b95d840e.jpg";